var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInformationIcon = function SvgInformationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "transparent",
    viewBox: "0 0 30 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 .278C7.158.278.778 6.658.778 14.501c0 7.841 6.38 14.222 14.222 14.222s14.222-6.38 14.222-14.222S22.842.277 15 .277m1.333 21.012a1.334 1.334 0 0 1-2.666 0v-8.123a1.334 1.334 0 0 1 2.666 0zM15 10.5a1.78 1.78 0 0 1-1.778-1.777c0-.98.797-1.778 1.778-1.778a1.78 1.78 0 0 1 1.778 1.778A1.78 1.78 0 0 1 15 10.5"
  })));
};
export default SvgInformationIcon;